interface PairingCooldownNoticeProps {
  /** `m:ss` until a new code can be requested. */
  formattedTime: string;
  /** Whether the code already sent is still enterable. */
  codeStillValid: boolean;
}

/**
 * The generate-code cooldown, shown as a wait rather than a failure.
 *
 * The server holds a second code back for ten minutes. Rendered as an error
 * that reads as "this is broken", and users retry harder — which is exactly
 * what the cooldown refuses. Rendered as a countdown beside a code that still
 * works, it reads as what it is.
 */
export function PairingCooldownNotice({
  formattedTime,
  codeStillValid,
}: PairingCooldownNoticeProps) {
  return (
    <div className="mt-3 bg-amber-50 border border-amber-200 rounded-md p-3">
      <p className="text-sm text-amber-800">
        {codeStillValid ? (
          <>
            Your code is still valid — enter it below, or request a new one in{" "}
            <strong>{formattedTime}</strong>.
          </>
        ) : (
          <>
            We just sent a code. You can request another in{" "}
            <strong>{formattedTime}</strong>.
          </>
        )}
      </p>
    </div>
  );
}
